export const isBlackWeek = () => {
    const today = new Date();
    const startDate = new Date("2024-11-25T00:00:00");
    const endDate = new Date("2024-12-01T23:59:59");
  
    return today >= startDate && today <= endDate;
  };
  